import { render, staticRenderFns } from "./SvgBase.vue?vue&type=template&id=4aa96708&"
import script from "./SvgBase.vue?vue&type=script&lang=js&"
export * from "./SvgBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports